import React from 'react';
import DatatableList from '../datatable';
import { Typography } from '@material-ui/core';
import useStyles from '../../styles';

interface IProps {
  registration_received_id: number;
}
const FixedEstablishmentsReceived = (props: IProps) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.tableHeader}>
        <Typography component={'p'} variant={'h5'}>
          Fixed Establishments Received
        </Typography>
      </div>
      <DatatableList
        registration_received_id={props.registration_received_id}
      />
    </React.Fragment>
  );
};

export default FixedEstablishmentsReceived;
